import type { IconDef } from '../types';

export const rightChevron: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M6.0025 24.0025C5.7425 24.0025 5.4925 23.9025 5.2925 23.7125C4.9025 23.3225 4.9025 22.6925 5.2925 22.3025L15.5925 12.0025L5.2925 1.7125C4.9025 1.3225 4.9025 0.6825 5.2925 0.2925C5.6825 -0.0975 6.3225 -0.0975 6.7125 0.2925L17.7125 11.2925C17.9025 11.4825 18.0025 11.7325 18.0025 12.0025C18.0025 12.2725 17.8925 12.5225 17.7125 12.7125L6.7125 23.7125C6.5125 23.9125 6.2625 24.0025 6.0025 24.0025Z',
    },
  ],
};
